import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app.service';
import { UtilsService } from '../../shared/utils.service';
import { HazardsAccountHierarchyOfControlsComponent } from '../hazards-account-hierarchy-of-controls/hazards-account-hierarchy-of-controls.component';

@Component({
  selector: 'app-hazards-hierarchy-of-controls',
  templateUrl: './hazards-hierarchy-of-controls.component.html',
  styleUrls: ['./hazards-hierarchy-of-controls.component.scss']
})
export class HazardsHierarchyOfControlsComponent implements OnInit {

  constructor(
    public app: AppService,
    public utils: UtilsService
    ) { }

  ngOnInit() {
  }

  onViewCompanyHierarchyOfControl() {
    this.utils.showComponentDialog(
      HazardsAccountHierarchyOfControlsComponent
    );
  }

}
